import { z } from 'zod';
import { HttpsUrlSchema } from '../util/url.js';
export const OwnerAssetsSchema = z.object({
    assetBaseUrl: HttpsUrlSchema,
    logoUrl: HttpsUrlSchema,
    logoAlt: z.string().min(1),
    welcomeHeaderImageUrl: HttpsUrlSchema.optional(),
    welcomeHeaderImageAlt: z.string().optional(),
    welcomeButtonLogoUrl: HttpsUrlSchema.optional(),
    welcomeButtonLogoAlt: z.string().optional(),
});
